<template>
  <div>
    <div class="short-text">{{ params.value }}</div>
    {{ params.value.length > 80 ? "..." : "" }}
  </div>
</template>

<style lang="scss" scoped>
.short-text {
  overflow: hidden;
  max-height: 68px;
  max-width: 100%;
}
</style>